/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { useEffect } from "react";
import { API } from "../../../globals/globals";
import { useLocation } from "react-router-dom";
import { useStoreDispatch } from "../../../store/hooks";
import { useGetDeviceByKeyQuery } from "../../../store/api/deviceConfig/deviceConfigApiSlice";
import { setSelectedDevice } from "../../../store/api/devices/reducers";
import { useSelector } from "react-redux";
import { IFullDeviceDetails } from "../../../store/api/deviceConfig/types";
import { selectedDeviceSelector } from "../../../store/api/devices/selectors";

export const useSummaryDisplay = () => {
  const dispatch = useStoreDispatch();
  const location = useLocation();
  const locationPath = location?.pathname.split("/");
  const selectedDevice: IFullDeviceDetails = useSelector(selectedDeviceSelector);
  const deviceObjectKey = selectedDevice?.objectKey || locationPath[2];
  const args = {
    filters: `key=objectKey&value=${deviceObjectKey}&weightType=FULL`,
    deviceKey: deviceObjectKey,
  };

  const { data, isLoading, refetch } = useGetDeviceByKeyQuery(args, {
    pollingInterval: API.ENDPOINTS.DEVICEBYKEY.pollingInterval || API.POLLING_INTERVAL,
    skip: !!deviceObjectKey ? false : true,
  });

  useEffect(() => {
    if (!!deviceObjectKey) {
      refetch();
    }
  }, [deviceObjectKey, refetch]);

  useEffect(() => {
    data?.data[0] != null && Object.keys(data?.data[0])?.length > 0 && dispatch(setSelectedDevice({ ...data?.data[0], ...data?.deviceParams }));
  }, [data, dispatch]);

  return {
    data,
    isLoading,
  };
};
